"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCountryNameProperty = exports.countryNamePropertyDefinition = void 0;
exports.countryNamePropertyDefinition = {
    view: { label: 'Country name' },
    constraints: [
        {
            name: 'maxLength',
            argument: 35,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'country-name',
};
const isCountryNameProperty = (prop) => {
    return prop.name === exports.countryNamePropertyDefinition.name;
};
exports.isCountryNameProperty = isCountryNameProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS1uYW1lLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY291bnRyeS1uYW1lLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGNBQWMsRUFBRTtJQUMvQixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==